module.exports = __webpack_public_path__ + "static/logo-speed-f21128b09c6f179ea96857790d694e04.png";